// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { CompaniesDataAppModule } from './app.module';
bootstrapAppModule(CompaniesDataAppModule);
